import React, { useEffect, useState } from "react";
import CreativeCreation from "./CreativeCreation";
import { SlDrawer, SlOption, SlSelect, SlInput, SlButton, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Select from "react-select";
import config from "../../config";
import Paginator from "../../shared/Paginator";
import { formatDateWithTime } from "../../utils/dateFormat";
import { Modal } from "react-bootstrap";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import PreviewFrameEdit from "../PreviewFrameEdit";
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from "../../utils/Debounce";
import {SetComponentId } from '../../redux/counterSlice'
import { creativeTypeOps, roles, types } from "../../utils/constants";
// import { SlButton, SlDrawer } from '@shoelace-style/shoelace/dist/react';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import FilterSvg from '../../assets/images/filter.svg'


const initial_state = [];
export const CreativeContext = React.createContext();

function AddCreative() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(6))
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  const statuses = [
    {
      value: "all",
      label: "All",
    },
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Inactive",
      label: "Inactive",
    },
  ];
  const [loader, setLoader] = useState(false);
  const [editdata, setEditData] = useState(initial_state);
  const [flag, setFlag] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [preview, setPreview] = useState({});
  const [showLogs, setShowLogs] = useState(false);
  const [logData, setLogData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const role = localStorage.getItem("role");

    if (role !== roles.ops) navigate("/pagenotfound");
  });
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const [show, setShow] = useState(false);
  const [createdEdited, setCreatedEdited] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [showFilter, setShowFilter] = useState(false)
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const [data, setData] = useState([]);
  const HeaderSearch = useSelector(state => state.Head.adssearch)

  const loadData = async (
    searchString = "",
    page = 0,
    status = "all",
    type = "all"
  ) => {
    setLoader(true);
    let obj = {
      search: searchString,
      sub_type: type,
      status,
    };
    try {
      const response = await api({
        url: `/creatives/getCreatives`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: obj,
        },
      });
      setData(response.data.data);
      setTotalPages(Math.ceil(response.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error.response.status === 401) navigate("/");
    }
  };
  const handleClone = async (creative_id) => {
    try {
      const response = await api({
        url: `/creatives/cloneCreative`,
        method: "POST",
        responseType: "json",
        data: {
          creative_id: creative_id,
        },
      });
     loadData(search, currentPage, status, type);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/");
      }
      console.error("Error cloning creative:", error);
    }
  };
  const handlePreview = () => {
    setShowPreview(!showPreview);
  };
  const handlePreviewdata = (item) => {
    if (item) setPreview(item);
  };
  useEffect(() => {
    handlePreviewdata();
  }, [preview]);

  useEffect(() => {
    if (show === false) {
      setEditData([]);
      if (createdEdited) {
        loadData(search, currentPage, status, type);
        setCreatedEdited(false);
      }
    }
  }, [show]);

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  useEffect(() => {
    loadData(search, currentPage, status, type);
  }, [currentPage]);

  const handleshow = (data) => {
    setShow(data);
  };

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0, status, type);
  }
  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0, status, type);
  };
  const changeSelectOptionHandler = (event) => {
    setType(event.target.value);
    setCurrentPage(0);
    loadData(search, 0, status, event.target.value);
  };
  const changeSelectHandler = (event) => {
    setStatus(event.target.value);
    setCurrentPage(0);
    loadData(search, 0, event.target.value, type);
  };
  const sortLogs = (logs) => {
    if (!logs || Object.keys(logs).length === 0) {
      return {}; // Return an empty object if no logs are present
    }
    // Convert the object to an array of [key, value] pairs
    const sortedEntries = Object.entries(logs)
      .sort((a, b) => {
        // Extract the numbers after the "-" in the key
        const numA = a[0].split('-')[1];
        const numB = b[0].split('-')[1];
        return numB - numA;  // Sorting by ascending number
      });

    // Convert the sorted array back into an object or keep it as an array
    return Object.fromEntries(sortedEntries);
  };
  return (
    <>
      <div className="flex items-center mb-3">
        <h5>Creative List </h5>
        <aside className="flex items-center ml-auto gap-3 mobHide">
          <div className="ml-auto">
            <SlInput
            className="w-60"
              size="medium"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search By Creative Name">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            {/* <input
              className="form-control"
              type="text"
              id="myInput"
              onChange={debounce(searchData, 500)}
              placeholder="Search By Creative Name"
            /> */}
          </div>
          <div>
            <SlSelect
              size="medium"
              className="w-[10.9rem]"
              placeholder="Select Type"
              defaultValue={type}
              onSlChange={changeSelectOptionHandler}>
              <SlIcon library="lucide" name="image" slot="prefix"></SlIcon>
              {types.map((option) => (
                <SlOption key={option.value} value={option.value}>
                  {option.label}
                </SlOption>
              ))}
            </SlSelect>
            {/* <Select
              placeholder="Select Type"
              defaultValue={type}
              options={types}
              onChange={changeSelectOptionHandler}
            ></Select> */}
          </div>
          <div>
            <SlSelect
              size="medium"
              className="w-[10.9rem]"
              placeholder="Select Status"
              defaultValue={status}
              onSlChange={changeSelectHandler}>
              <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
              {statuses.map((option) => (
                <SlOption key={option.value} value={option.value}>
                  {option.label}
                </SlOption>
              ))}
            </SlSelect>
            {/* <Select
              placeholder="Select Status"
              defaultValue={status}
              options={statuses}
              onChange={changeSelectHandler}
            ></Select> */}
          </div>
          <div className={`${window.innerWidth <= 767 ? 'w-full' : 'w-40'}`}>
            <SlButton
              variant="primary"
              size="medium"
              className="w-full"
              value={show}
              onClick={() => {
                setFlag("add");
                setSearch("");
                handleshow(true);
              }}>Add Creative</SlButton>
          </div>
        </aside>
        <div className="flex gap-2 ml-auto mobileOnly">
        <img src={FilterSvg} className="w-6 " onClick={() => setShowFilter(true)} alt="filter"></img>
        <div className={`mobileOnly`}>
            <SlButton
              variant="primary"
              size="medium"
              className="w-40"
              value={show}
              onClick={() => {
                setFlag("add");
                setSearch("");
                handleshow(true);
              }}>Add Creative</SlButton>
          </div>
          </div>
      </div>
      <div className="mb-2">
        <ScrollContainer>
        <table className='table table-bordered'>
          <thead className="sticky top-0">
            <tr>
              <th >Creative Name</th>
              <th >Created Date</th>
              <th >Creative Type</th>
              <th >Sub Type</th>
              <th >Status</th>
              {/* <th>Active/Inactive</th> */}
              <th >Actions</th>
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data.map((item) => {
                return (
                  <tr key={item.creative_id} className="group/details hover:bg-slate-100">
                    <td className="wgt-600">{item.name}</td>
                    <td>{formatDateWithTime(item.created_date)}</td>
                    <td>{creativeTypeOps.find(j => j.value === item.creative_type)?.label}</td>
                    <td>{types.find(j => j.value === item.sub_type)?.label === "Full Image" ? <div><sl-icon name="image"></sl-icon><span className="ml-2">Full Image</span> </div>:
                      types.find(j => j.value === item.sub_type)?.label === "Gallery" ? <div><sl-icon name="images"></sl-icon><span className="ml-2">Gallery</span></div> :
                        types.find(j => j.value === item.sub_type)?.label === "Full Video" ? <div><sl-icon name="play-circle"></sl-icon><span className="ml-2">Full Video</span></div> :
                          types.find(j => j.value === item.sub_type)?.label === "Half Video" ? <div><sl-icon name="play-circle"></sl-icon><span className="ml-2">Half Video</span></div> :
                            types.find(j => j.value === item.sub_type)?.label === "Fullvideo or Gif" ? <div><sl-icon name="filetype-gif"></sl-icon><span className="ml-2">Fullvideo or Gif</span></div> :
                              types.find(j => j.value === item.sub_type)?.label === "Promoted Image Story" ? <div><sl-icon name="image"></sl-icon><span className="ml-2">Promoted Image Story</span></div> :
                                types.find(j => j.value === item.sub_type)?.label === "Promoted Gallery" ? <div><sl-icon name="images"></sl-icon><span className="ml-2">Promoted Gallery</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "WebView Ad" ? <div><sl-icon name="globe"></sl-icon><span className="ml-2">WebView Ad</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Comment Ad" ? <div><sl-icon library="lucide" name="message-circle"></sl-icon><span className="ml-2">Comment Ad</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Search" ? <div><sl-icon library="lucide" name="search"></sl-icon><span className="ml-2">Search</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Unread" ? <div><sl-icon library="lucide" name="eye-off"></sl-icon><span className="ml-2">Unread</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "News-Image Flip" ? <div><sl-icon library="lucide" name="box"></sl-icon><span className="ml-2">News-Image Flip</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "News-Image Logo" ? <div><sl-icon library="lucide" name="layout-list"></sl-icon><span className="ml-2">News-Image Logo</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "News-Short Description" ? <div><sl-icon library="lucide" name="layout-list"></sl-icon><span className="ml-2">News-Short Description</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Video Expandable" ? <div><sl-icon library="lucide" name="video"></sl-icon><span className="ml-2">Video Expandable</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Video Endcard" ? <div><sl-icon library="lucide" name="video"></sl-icon><span className="ml-2">Video Endcard</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Video Skippable" ? <div><sl-icon library="lucide" name="skip-forward"></sl-icon><span className="ml-2">Video Skippable</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Bottom Rectangle" ? <div><sl-icon library="lucide" name="box"></sl-icon><span className="ml-2">Bottom Rectangle</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Brand Ad" ? <div><sl-icon library="lucide" name="star"></sl-icon><span className="ml-2">Brand Ad</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Rectangle Classified" ? <div><sl-icon library="lucide" name="star"></sl-icon><span className="ml-2">Rectangle Classified</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Square Classified" ? <div><sl-icon library="lucide" name="star"></sl-icon><span className="ml-2">Square Classified</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Frame Post" ? <div><sl-icon library="lucide" name="layout-list"></sl-icon><span className="ml-2">Frame Post</span></div> :
                                  types.find(j => j.value === item.sub_type)?.label === "Recommend Image" ? <div><sl-icon library="lucide" name="star"></sl-icon><span className="ml-2">Recommend Image</span></div> :
                                   types.find(j => j.value === item.sub_type)?.label === "Recommend Promoted Story" ? <div><sl-icon library="lucide" name="star"></sl-icon><span className="ml-2">Recommend Promoted Story</span></div> :
                                   <div><sl-icon name="play-circle"></sl-icon><span className="ml-2">Promoted Video Story</span></div>}</td>
                    <td className="badge badge-success">{item.status === 0 ? "Inactive" : "Active"}</td>
                    <td >
                      <div className="d-flex gap-3" style={{ fontSize: "20px" }}>
                        <sl-tooltip content="Preview Creative">
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => { handlePreview(); handlePreviewdata(item); }}></sl-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Edit Creative">
                          <sl-icon-button
                            library="lucide"
                            name="edit"
                            onClick={() => { setFlag("edit"); setEditData(item); handleshow(true); }}></sl-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Clone Creative">
                          <sl-icon-button
                            library="lucide"
                            name="files"
                            onClick={() =>handleClone(item.creative_id)}></sl-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Logs">
                          <sl-icon-button
                            library="lucide"
                            name="terminal-square"
                            onClick={() =>{setShowLogs(true);setLogData(sortLogs(item.logs))}}></sl-icon-button>
                        </sl-tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="17" />
          ) : (
            <TableLoader colspan="17" />
          )}
        </table>
        </ScrollContainer>
      </div>
      <div className="right-fixed">
        {totalPages > 1 && <Paginator
          pageCount={totalPages}
          handlePageClick={handlePageClick}
          forcePage={currentPage}
        />}
      </div>
      <section className="creativeAdd">
        {show && (
          <CreativeCreation
            handleshow={handleshow}
            editdata={editdata}
            flag={flag}
            createdEdited={setCreatedEdited}
          ></CreativeCreation>
        )}
      </section>
      <SlDrawer label="Preview" open={showPreview} onSlAfterHide={handlePreview}>
        <CreativeContext.Provider value={{ preview, setPreview }}>
          <PreviewFrameEdit showPreview={showPreview} />
        </CreativeContext.Provider>
      </SlDrawer>
      {/* <Modal show={showPreview} onHide={handlePreview}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreativeContext.Provider value={{ preview, setPreview }}>
            <PreviewFrameEdit />
          </CreativeContext.Provider>
        </Modal.Body>
      </Modal> */}
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="flex items-center ml-auto gap-3 flex-wrap">
          <div className="w-full">
            <SlInput
              size="medium"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search By Creative Name">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            {/* <input
              className="form-control"
              type="text"
              id="myInput"
              onChange={debounce(searchData, 500)}
              placeholder="Search By Creative Name"
            /> */}
          </div>
          <div className="w-full">
            <SlSelect
              size="medium"
              placeholder="Select Type"
              defaultValue={type}
              onSlChange={changeSelectOptionHandler}>
              <SlIcon library="lucide" name="image" slot="prefix"></SlIcon>
              {types.slice(0, 11).map((option) => (
                <SlOption key={option.value} value={option.value}>
                  {option.label}
                </SlOption>
              ))}
            </SlSelect>
            {/* <Select
              placeholder="Select Type"
              defaultValue={type}
              options={types}
              onChange={changeSelectOptionHandler}
            ></Select> */}
          </div>
          <div className="w-full">
            <SlSelect
              size="medium"
              placeholder="Select Status"
              defaultValue={status}
              onSlChange={changeSelectHandler}>
              <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
              {statuses.map((option) => (
                <SlOption key={option.value} value={option.value}>
                  {option.label}
                </SlOption>
              ))}
            </SlSelect>
            {/* <Select
              placeholder="Select Status"
              defaultValue={status}
              options={statuses}
              onChange={changeSelectHandler}
            ></Select> */}
          </div>
          
        </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
      <SlDrawer
        open={showLogs}
        onSlRequestClose={handleRequestClose}
        label="Logs"
        onSlAfterHide={()=>{setShowLogs(false);setLogData([])}}
        style={{ "--size": `${window.innerWidth <= 767 ? "100vw" : "60vw"}` }}
      >
        <>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Field</th>
              <th>Previous</th>
              <th>Updated</th>
              <th>Updated By</th>
              <th>Updated At</th>
            </tr>
          </thead>
          {logData && Object.keys(logData).length > 0 ? <tbody>
            {Object.keys(logData).map((item) => {
              const field = item?.split("-")[0];
              const from_value = logData[item]?.from;
              const to_value = logData[item]?.to;
              const user_name = logData[item]?.user_name;
              const updated_at = logData[item]?.date;
              return (
                <tr key={item}>
                  <td>{field}</td>
                  <td>{from_value || "-"}</td>
                  <td>{to_value || "-"}</td>
                  <td>{user_name}</td>
                  <td>{formatDateWithTime(updated_at) || "-"}</td>
                </tr>
              );
            })}
          </tbody> : <NoDataFound colspan="5" />}
        </table>
        </>
      </SlDrawer>
    </>
  );
}
export default AddCreative;
